/* @flow */
import ChatMember from 'entities/ChatMember';
import Group from 'entities/Group';
// @ts-ignore
import PotentialChatMember from 'entities/PotentialChatMember';
// @ts-ignore
import Relationship from 'entities/Relationship';
import { rootGroup } from 'entities/RootGroup';
import Subscriber from 'entities/Subscriber';
// @ts-ignore
import User from 'entities/User';
import { promiseRelationship } from 'chat/utils/ChatPromises';

// basically an entity that has .id and .getName()\
// NOTE: The id MUST be the id of a User!
export type NamedInterlocutor = PotentialChatMember | Subscriber | User | ChatMember | number;

// TODO maybe make this a promise for the pathname and let the component do
// the router pusher so we're not passing the router around
export function pushRouterToChatWithMember(
  router: { push: Function },
  otherMember: NamedInterlocutor,
  group?: Group,
  catchHandler?: Function
): Promise<void> {
  return promiseRelationship(otherMember)
    .then(relationship => {
      if (group) {
        routeWithSharedGroup(router, group, relationship);
        return;
      }
      goToChatForRelationship(relationship, router);
    })
    .catch(err => {
      console.error(`ChatRouteHelper failed to load relationship - ${err}`);
      goToAllClasses(router);
      if (catchHandler) {
        catchHandler();
      }
    });
}

function goToChatForRelationship(relationship: Relationship, router: { push: Function }): void {
  const chat = relationship.getChat();
  if (chat) {
    goToAllClasses(router, `${chat.id}`);
  } else {
    goToAllClasses(router, `new/${relationship.id}`);
  }
}

function goToAllClasses(router: { push: Function }, endPath?: string) {
  router.push({ pathname: `/classes/${rootGroup.getCodeOrError()}/messages/${endPath || ''}` });
}

function routeWithSharedGroup(
  router: { push: Function },
  commonGroup: Group,
  relationship: Relationship
): void {
  const chat = relationship.getChat();
  const pathname = chat
    ? `/classes/${commonGroup.getCodeOrError()}/messages/${chat.id}`
    : `/classes/${commonGroup.getCodeOrError()}/messages/new/${relationship.id}`;
  router.push({ pathname });
}
